import { render, staticRenderFns } from "./BancoHoras.vue?vue&type=template&id=16f8a304&scoped=true"
import script from "./BancoHoras.vue?vue&type=script&lang=js"
export * from "./BancoHoras.vue?vue&type=script&lang=js"
import style0 from "./BancoHoras.vue?vue&type=style&index=0&id=16f8a304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f8a304",
  null
  
)

export default component.exports